var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-none",attrs:{"color":"primary","disabled":_vm.allowPayment || _vm.isAllRoomStaysBooked || _vm.isRoomSoldOut,"ripple":false,"block":"","tile":"","x-large":""},on:{"click":_vm.bookRoom}},[_vm._v("\n  "+_vm._s(_vm.$t('General#Button Book now'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }